export const isBlank = {
  id: 'isBlank',
  value: 'Empty',
};
export const isNotBlank = {
  id: 'isNotBlank',
  value: 'NotEmpty',
};

export const equals = {
  id: 'equals',
  value: 'Equals',
};

export const doesNotEqual = {
  id: 'doesNotEqual',
  value: 'NotEqual',
};

export const startsWith = {
  id: 'startsWith',
  value: 'BeginsWith',
};

export const doesNotStartWith = {
  id: 'doesNotStartWith',
  value: 'DoesNotBeginWith',
};

export const endsWith = {
  id: 'endsWith',
  value: 'EndsWith',
};

export const doesNotEndWith = {
  id: 'doesNotEndWith',
  value: 'DoesNotEndWith',
};

export const contains = {
  id: 'contains',
  value: 'Contains',
};

export const doesNotContain = {
  id: 'doesNotContain',
  value: 'DoesNotContain',
};
